
import React, {FC} from 'react';

import Empty from './svgs/empty.inline.svg';
import Filled from './svgs/filled.inline.svg';

import * as styles from './styles.module.scss';

export type QuestionProps = {
	index: number
	question: string
	rating: number
	onStars: (index: number, rating: number) => void
}

export const Question: FC<QuestionProps> = ({index, question, rating, onStars}) => {
	const stars = [1, 2, 3, 4, 5];
	return (
		<div className={styles.question}>
			<h1>{question}</h1>
			<div>
				{stars.map((i) => (
					<div key={i} onClick={() => onStars(index, i)}>
						{i <= rating ? <Filled /> : <Empty />}
					</div>
				))}
			</div>
		</div>
	);
};
